// src/components/SupportPage.js
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import React, { useState } from 'react';
import '../Style/Support.css';
import { FaEnvelope, FaPhone, FaQuestionCircle } from 'react-icons/fa';

export default function SupportPage() {
  const [showDetails, setShowDetails] = useState(false);

  const email = 'go-fmafricaprivateen@kpmg.com';
  const ccList = 'natuga@kpmg.co.ke,mrapando@kpmg.co.ke';
  const mailto = `mailto:${encodeURIComponent(email)}?cc=${encodeURIComponent(ccList)}`;

  return (
    <div className="support-container">
      <div className="support-card">
        <FaQuestionCircle className="support-icon" />
        <h2>Need Assistance?</h2>
        <p>We're here to help with your questions or technical issues.</p>
        
        {!showDetails && (
          <button className="support-button" onClick={() => setShowDetails(true)}>
            Contact Support
          </button>
        )}

        {showDetails && (
          <div className="support-details">
            <p>
              <FaEnvelope />{' '}
              <a href={mailto} className="support-link">Email Our Team</a>
            </p>
            <p>
              <FaPhone /> +254202806000
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
